import { render, staticRenderFns } from "./CreditosCliente.vue?vue&type=template&id=21a7ad90&scoped=true"
import script from "./CreditosCliente.vue?vue&type=script&lang=js"
export * from "./CreditosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7ad90",
  null
  
)

export default component.exports